import React from 'react';
import { Button } from 'shared/ui/Button';
import { SideModalFooter, useModalsActions } from 'shared/ui/SideModal';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';

interface CampaignEditModalFooterProps {
  isEditMode: boolean;
  submit: () => void;
  isLoading: boolean;
}
export function CampaignEditModalFooter({ isEditMode, submit, isLoading }: CampaignEditModalFooterProps) {
  const { close } = useModalsActions();

  return (
    <>
      {isEditMode && (
        <SideModalFooter>
          <div className="flex justify-between gap-4">
            <Button
              className="w-full"
              onClick={close}
              variant="outline"
              {...getDataAutoTestAttributes(['button-campaign-edit-close'])}
            >
              Cancel
            </Button>
            <Button
              onClick={submit}
              className="w-full-screen w-[231px] shrink-0"
              loading={isLoading}
              {...getDataAutoTestAttributes(['button-campaign-edit-save'])}
            >
              Save changes
            </Button>
          </div>
        </SideModalFooter>
      )}
    </>
  );
}
